module.exports = __webpack_public_path__ + "static/img/OIYO_logo.2502c59.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/project_logo/OIYO_logo.png
// module id = aVPz
// module chunks = 0